/***
 * Created on 2024/1/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import ic_sys_attention_svg from '../../static/img/utils/ic_sys_attention.svg';
import ic_sys_info_outline_white_svg from '../../static/img/utils/ic_sys_info_outline_white.svg';
import {useTranslation} from "react-i18next";
import EmailChangedDialog from "./EmailChangedDialog";


function BadgeEmailConfirm({organization, doRefresh}) {
    const { t } = useTranslation();
    // Defensive guard: organization may briefly be missing users[] during
    // navigation between views that source currentOrg from different
    // endpoints. Without this guard the row component throws and the whole
    // dashboard rerender breaks.
    const users = organization.users || [];
    const changed_users = users.filter(u => u?.email_changed);
    const user_count = changed_users?.length;
    const [showChangeDialog, setShowChangeDialog] = useState(false);

    return (
        <>
            {
                user_count > 0 &&
                <div className="badge badge-confirm-email-address">
                    <div className="badge-head">
                        <img src={ic_sys_attention_svg} className="display-block !w-12px !h-12px" alt=""/>
                    </div>
                    <div className="badge-body">
                        <div className="badge-info" onClick={() => setShowChangeDialog(true)}>
                            <div className="badge-info__text">{t('@{{user_count}} administrator(s) has changed the email addresses associated with their QNAP IDs.@', {user_count})}</div>
                        </div>
                    </div>
                </div>
            }

            {showChangeDialog && <EmailChangedDialog isOpenDialog={showChangeDialog} onClose={()=>setShowChangeDialog(false)} org={organization} emailChangedUsers={changed_users} />}
        </>

    )
}

function DefaultOrg({organization}) {
    const { t } = useTranslation();

    return (
        <>
            {
                organization.default &&
                <div className="badge badge-default-org">
                    <div className="badge-head">
                        <span>{t('@Default Organization@')}</span>
                        <img src={ic_sys_info_outline_white_svg} alt=""/>
                    </div>
                    <div className="badge-body">
                        <div className="badge-info">
                            {t('@This organization cannot be removed due to some cloud services may relies on this organization.@')}
                        </div>
                    </div>
                </div>
            }
        </>

    );
}

function BadgeGroup({organization, doRefresh}) {
    const { t } = useTranslation();

    return (
        <div className="badge-group">
            <BadgeEmailConfirm organization={organization} doRefresh={doRefresh}/>
            {organization.new && <div className="badge badge-new-create">{t('@New Created@')}</div>}
            <DefaultOrg organization={organization}/>
        </div>
    );
}

export default BadgeGroup;